import { defineComponent as _defineComponent } from 'vue'
import CheckboxInput from "@/components/ui/input/CheckboxInput.vue";
  import InputSearch from "@/components/ui/input/InputSearch.vue";
  import Modal from "@/components/ui/Modal.vue";
  import {
    computed,
    ref,
    watch,
    PropType,
  } from "vue";
  import { debounce } from "@/helpers/debounce";
  import plural from "@/features/plural";
  import { EstateInterface } from "@/types/EstateInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectProjectsModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    projects: {
      type: Array as PropType<EstateInterface[]>,
      default: () => {
        return [];
      },
    },
  },
  emits: ["close", "selectEstates", "searchEstates"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const searchQuery = ref("");

  const searchEstatesEmit = () => {
    emits("searchEstates", searchQuery.value);
  };

  const getSelectedProjects = computed(() => {
    return props.projects.filter((item: EstateInterface) => item.isSelected)
      .length;
  });

  const debounceSearch = debounce(searchEstatesEmit);

  watch(
    () => searchQuery.value,
    () => {
      debounceSearch();
    }
  );

  const close = () => {
    searchQuery.value = "";
    emits("close");
  };

const __returned__ = { emits, props, searchQuery, searchEstatesEmit, getSelectedProjects, debounceSearch, close, CheckboxInput, InputSearch, Modal, computed, ref, watch, PropType, get debounce() { return debounce }, get plural() { return plural }, get EstateInterface() { return EstateInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})